import React, { useState } from "react";
import BtnSlider from "../../../components/Slider/BtnSlider";
import { URL_S3 } from "../../../config/BaseUrl";
import GalleryMediaStats from "./GalleryMediaStats";
import useGalleryMediaDetails from "./useGalleryMediaDetails";

const PhotoGalleryDetails = ({ photoShareDetails, dataSlider = [], activeItemIndex = 0 }) => {
  const [slideIndex, setSlideIndex] = useState(activeItemIndex);
  const activeItem = dataSlider[slideIndex];
  const { loading, media } = useGalleryMediaDetails(activeItem?.id, photoShareDetails);

  const nextSlide = () => setSlideIndex((current) => current + 1 === dataSlider.length ? 0 : current + 1);
  const prevSlide = () => setSlideIndex((current) => current === 0 ? dataSlider.length - 1 : current - 1);

  return (
    <div className="main_area_fullscreen">
      <div className="full_screen_left">
        <div className="container-slider">
          {dataSlider.map((item, index) => (
            <div key={item.id} className={slideIndex === index ? "slide active-anim" : "slide"}>
              <img src={`${URL_S3}event_gallery/photo/${item.event_photo}`} alt="Gallery item" />
            </div>
          ))}
          {dataSlider.length > 1 ? <BtnSlider moveSlide={nextSlide} direction="next" /> : null}
          {dataSlider.length > 1 ? <BtnSlider moveSlide={prevSlide} direction="prev" /> : null}
        </div>
      </div>
      <aside className="full_screen_right">
        <GalleryMediaStats loading={loading} media={media} title="Photo details" />
      </aside>
    </div>
  );
};

export default PhotoGalleryDetails;
